export function isWebdriver() {
    return window.navigator.webdriver;
}
